export const getAvailabilityColor = (percentage: number): string => {
  if (percentage < 98) {
    return '#F3776D';
  }
  if (percentage < 99) {
    return '#F3C46D';
  }
  return '#86B29C';
};
